import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgChartLine = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M4.688 17.344c0 .467.377.843.843.843h14.625c.468 0 .844.377.844.844a.84.84 0 0 1-.844.844H5.531A2.53 2.53 0 0 1 3 17.344V4.969a.844.844 0 0 1 1.688 0zm10.128-3.653c-.299.359-.833.359-1.164 0l-2.809-2.75-2.777 2.75c-.299.359-.833.359-1.164 0-.327-.299-.327-.833 0-1.164l3.375-3.375a.83.83 0 0 1 .566-.246c.257 0 .472.088.598.246l2.809 2.781 4.184-4.187c.33-.327.864-.327 1.163 0 .359.33.359.865 0 1.164z"
    }));
export default SvgChartLine;
